/** Shared payload shape for Sourced facts.

A proof attempt is rating or count. Platform defaults to Google and a
loaded row keeps sourceUrl/captured filled; gating on those made clearing
stars 422 on every tenant that actually had stars (Viktor, loaded-row
payload). Same rule as the backend strip: no numbers → no proof.
*/
import type { LandingArtFactsPayload } from '@/services/landingPagesService';

export const ART_PLATFORMS = [
  'Google',
  'Facebook',
  'Yelp',
  'BBB',
  'Angi',
  'Trustpilot',
] as const;

export type ArtPlatform = (typeof ART_PLATFORMS)[number];

export interface ArtFactsForm {
  rating: string;
  count: string;
  platform: string;
  sourceUrl: string;
  captured: string;
  guarantee: string;
  hours: string;
  is247: boolean;
  offer: string;
  offerExpires: string;
  price: string;
}

export function buildArtFactsPayload(form: ArtFactsForm): LandingArtFactsPayload {
  const facts: LandingArtFactsPayload = {};
  const rating = form.rating.trim();
  const count = form.count.trim();
  const sourceUrl = form.sourceUrl.trim();
  const captured = form.captured.trim();
  const attemptingProof = Boolean(rating || count);
  if (attemptingProof) {
    facts.proof = {
      rating,
      reviews_count: count,
      platform: form.platform.trim(),
      source_url: sourceUrl,
      captured_at: captured,
    };
  }
  if (form.guarantee.trim()) {
    facts.guarantee = { text: form.guarantee.trim() };
  }
  if (form.hours.trim() || form.is247) {
    facts.hours = { text: form.hours.trim(), is_24_7: form.is247 };
  }
  if (form.offer.trim() || form.offerExpires.trim()) {
    facts.offer = { text: form.offer.trim(), expires: form.offerExpires.trim() };
  }
  if (form.price.trim()) {
    facts.entry_price = { text: form.price.trim() };
  }
  return facts;
}
